(() => {
  const key = 'qd:vat-display';
  let mode = 'net';
  try {
    const saved = sessionStorage.getItem(key);
    if (saved === 'gross' || saved === 'net') mode = saved;
  } catch {}

  class QdVatPrice extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('qd:vat-display-change', this.onModeChange);
      this.priceObserver = new MutationObserver(this.onPriceChange);
      this.priceObserver.observe(this, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['hidden', 'data-qd-vat-eligible'],
      });
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('qd:vat-display-change', this.onModeChange);
      this.priceObserver?.disconnect();
    }

    onClick = (event) => {
      const button = event.target.closest?.('[data-qd-vat-mode]');
      if (!button || !this.contains(button)) return;
      const next = button.dataset.qdVatMode;
      if (!['gross', 'net'].includes(next) || next === mode) return;
      mode = next;
      try {
        sessionStorage.setItem(key, mode);
      } catch {}
      window.dispatchEvent(new CustomEvent('qd:vat-display-change'));
    };

    onModeChange = () => this.update();

    onPriceChange = (records) => {
      const selector = '.qd-vat-money, [data-qd-vat-gross], [data-qd-vat-net]';
      if (records.some((record) =>
        (record.type === 'attributes' && record.target === this) ||
        record.target.parentElement?.closest('.qd-vat-money') ||
        [...record.addedNodes, ...record.removedNodes].some((node) =>
          node instanceof Element && (node.matches(selector) || node.querySelector(selector))
        )
      )) this.update();
    };

    update() {
      const eligible = this.hasAttribute('data-qd-vat-eligible');
      const net = eligible && mode === 'net';
      const controls = this.querySelector('[data-qd-vat-controls]');
      if (controls && controls.hidden === eligible) controls.hidden = !eligible;
      this.querySelectorAll('[data-qd-vat-gross]').forEach((item) => { if (item.hidden !== net) item.hidden = net; });
      this.querySelectorAll('[data-qd-vat-net]').forEach((item) => { if (item.hidden === net) item.hidden = !net; });
      this.querySelectorAll('[data-qd-vat-mode]').forEach((button) => {
        const pressed = String(button.dataset.qdVatMode === mode);
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      });
      const label = this.querySelector('[data-qd-vat-label]');
      const labelText = net ? this.dataset.netLabel : this.dataset.grossLabel;
      if (label && label.textContent !== labelText) label.textContent = labelText;
      const status = this.querySelector('[data-qd-vat-status]');
      const statusText = net ? this.dataset.netStatus : this.dataset.grossStatus;
      if (status && status.textContent !== statusText) status.textContent = statusText;
    }
  }

  if (!customElements.get('qd-vat-price')) customElements.define('qd-vat-price', QdVatPrice);
})();
